import * as $ from 'jquery';

var container;
var showBtn;
var closeBtn;

$(document).ready(function () {
    container = $(".js-main-menu");
    showBtn = $(".js-toggle-menu");
    closeBtn = $(".btn-menu-close");
    bindEvents();
});

/**
 * Bind events
 */
function bindEvents() {
    $(document).click(function (e) {
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            if (!showBtn.is(e.target) && showBtn.has(e.target).length === 0) {
                container.removeClass('shown');
            }

        }
    });
    $(showBtn).click(function (e) {
        e.preventDefault();
        container.addClass('shown');
    });
    $(closeBtn).click(function (e) {
        e.preventDefault();
        container.removeClass('shown');
    });
}

